<template>
  <div class="content">
    <div class="flex flex-between">
      <div class="flex-1"></div>
      <a-button type="primary" @click="handleAdd">
        {{ $t('新增') }}
      </a-button>
    </div>
    <CommonTable
      :columns="columns"
      :dataSource="tableData"
      :total="total"
      :showSetting="false"
      :showPagination="false"
    >
      <template v-slot:operation="{ record }">
        <a @click="handleEdit(record)">{{ $t('编辑') }}</a>
      </template>
    </CommonTable>

    <a-modal
      :title="modalTitle"
      :visible="visible"
      :confirmLoading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
        :label-col="{ span: 4 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item :label="$t('编码')" prop="code">
          <a-input v-model.trim="form.code" :disabled="isEdit" :placeholder="$t('请输入编码')" />
        </a-form-model-item>
        <a-form-model-item :label="$t('名称')" prop="name">
          <a-input v-model.trim="form.name" :placeholder="$t('请输入名称')" />
        </a-form-model-item>
        <a-form-model-item :label="$t('类型')" prop="type">
          <a-select v-model="form.type" :placeholder="$t('请选择类型')">
            <a-select-option
              v-for="item in settlement_method_type"
              :key="item.code"
              :value="item.code"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import CommonTable from '@/component/commonTable'
export default {
  name: 'SettlementMethod',
  components: { CommonTable },
  data() {
    return {
      tableData: [],
      total: 0,
      visible: false,
      confirmLoading: false,
      isEdit: false,
      form: {
        id: 0,
        code: '',
        name: '',
        type: undefined,
      },
      rules: {
        code: [{ required: true, message: this.$t('请输入编码'), trigger: 'blur' }],
        name: [{ required: true, message: this.$t('请输入名称'), trigger: 'blur' }],
        type: [{ required: true, message: this.$t('请选择类型'), trigger: 'change' }],
      },
    }
  },
  mounted() {
    this.getList()
  },
  computed: {
    ...mapState(['settlement_method_type']),
    ...mapGetters(['settlementMethodTypeMapping']),
    modalTitle() {
      return this.isEdit ? this.$t('编辑结算方式') : this.$t('新增结算方式')
    },
    columns() {
      return [
        {
          title: this.$t('编码'),
          dataIndex: 'code',
        },
        {
          title: this.$t('名称'),
          dataIndex: 'name',
        },
        {
          title: this.$t('类型'),
          dataIndex: 'type',
          customRender: (text) => this.settlementMethodTypeMapping[text] || text,
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          width: 100,
        },
      ]
    },
  },
  methods: {
    getList() {
      http({
        url: api.getSettlementMethodList,
        success: (res) => {
          this.tableData = res.result.list
          this.total = res.result.total
        },
      })
    },
    handleAdd() {
      this.isEdit = false
      this.resetForm()
      this.visible = true
    },
    handleEdit(record) {
      this.isEdit = true
      this.visible = true
      this.form = {
        id: record.id,
        code: record.code,
        name: record.name,
        type: record.type,
      }
    },
    handleCancel() {
      this.visible = false
      this.resetForm()
    },
    resetForm() {
      this.form = {
        id: 0,
        code: '',
        name: '',
        type: undefined,
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    handleOk() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.confirmLoading = true
          http({
            url: api.createOrUpdateSettlementMethod,
            type: 'post',
            data: {
              ...this.form,
            },
            success: (res) => {
              this.confirmLoading = false
              if (res.success) {
                this.$message.success(this.isEdit ? this.$t('编辑成功') : this.$t('新增成功'))
                this.visible = false
                this.getList()
              } else {
                this.$message.error(
                  res.msg || (this.isEdit ? this.$t('编辑失败') : this.$t('新增失败'))
                )
              }
            },
            fail: () => {
              this.confirmLoading = false
            },
          })
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.mb20 {
  margin-bottom: 20px;
}
</style>
